import { useFocusManager } from './useFocusManager.js';
export { UseFocusManagerFocusControl as UseListboxFocusControl } from './useFocusManager.js';
import { UseKeyManagerOrientation } from './useKeyManager.js';
export { UseKeyManagerDirection as UseListboxDirection, UseKeyManagerOrientation as UseListboxOrientation } from './useKeyManager.js';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useListbox = function useListbox(_ref) {
  var items = _ref.items,
      disableKeyManager = _ref.disableKeyManager,
      onActiveItemChangeCallback = _ref.onActiveItemChange,
      _ref$itemPropGenerato = _ref.itemPropGenerator,
      userItemPropGeneratorCallback = _ref$itemPropGenerato === void 0 ? function () {
    return [null, {}];
  } : _ref$itemPropGenerato,
      props = _objectWithoutProperties(_ref, ["items", "disableKeyManager", "onActiveItemChange", "itemPropGenerator"]);

  var _useFocusManager = useFocusManager(_objectSpread({
    orientation: UseKeyManagerOrientation.Vertical,
    items: items,
    disableManager: disableKeyManager,
    onActiveItemChange: function onActiveItemChange(event) {
      if (typeof onActiveItemChangeCallback === 'function') {
        onActiveItemChangeCallback(event);
      }
    },
    itemPropGenerator: function itemPropGenerator(config) {
      // create item props from consuming application side
      var _userItemPropGenerato = userItemPropGeneratorCallback(config),
          _userItemPropGenerato2 = _slicedToArray(_userItemPropGenerato, 2),
          key = _userItemPropGenerato2[0],
          props = _userItemPropGenerato2[1]; // merge the users item props with the required listbox props


      // merge the users item props with the required listbox props
      return [key, _objectSpread(_objectSpread({}, props), {}, {
        role: 'option'
      })];
    }
  }, props)),
      containerProps = _useFocusManager.containerProps,
      activeItem = _useFocusManager.activeItem,
      itemProps = _useFocusManager.itemProps,
      keyManagerProps = _objectWithoutProperties(_useFocusManager, ["containerProps", "activeItem", "itemProps"]);

  var listboxProps = _objectSpread({
    role: 'listbox'
  }, containerProps);

  return _objectSpread(_objectSpread({}, keyManagerProps), {}, {
    activeItem: activeItem,
    listboxProps: listboxProps,
    optionProps: itemProps
  });
};

export { useListbox };
